import DOMPurify from 'dompurify';
import { Fragment, memo } from 'react';
import * as dayjs from 'dayjs';
import RatingStars, { CustomStarRatings } from 'components/RatingStars';
import useQueryParams from 'hooks/useQueryParams';

const keyLabels = {
  GEEK: { colorLabel: 'success', label: 'Geeks', key: 'geek' },
  NOTE: { colorLabel: 'danger', label: 'Notes', key: 'note' },
};

function TopicRatingHistory(props) {
  const results = props.data?.quizRatings || [];

  const query = useQueryParams();
  const subtopicID = query.get('subtopic');

  return (
    <>
      {results?.length > 0 ? (
        <>
          {results?.map?.((q) => {
            return (
              <Fragment key={q._id}>
                <div className="row">
                  <div className="col-12 my-4">
                    <div className="lessonWrap__text">
                      {/* <RatingStars starProps={{ readOnly: true }} value={q?.currentRating} /> */}
                      <div className="d-flex align-items-center">
                        <span>Current rating is </span>{' '}
                        <CustomStarRatings value={q?.currentRating || 0} />
                      </div>
                      <span
                        class={`badge badge-${
                          keyLabels[q?.applicableTo]?.colorLabel
                        } badge-pill mx-4`}
                        style={{ lineHeight: 'unset', height: 'fit-content' }}
                      >
                        {keyLabels[q?.applicableTo]?.label}
                      </span>
                      <span>{q?.[keyLabels[q?.applicableTo]?.key]?.title}</span>
                    </div>
                    <p
                      className="my-4"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(q?.question?.title),
                      }}
                    ></p>
                    {q?.ratingsHistory?.length > 0 ? (
                      <>
                        <div class="table-responsive app-l-tab-sub">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">
                                  {subtopicID ? `Sub Lessons's` : `Lessons's`} Quality Rating
                                </th>
                                <th scope="col">Rated by</th>
                                <th scope="col">Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {q?.ratingsHistory?.map?.((rq, i) => {
                                return (
                                  <tr key={rq._id}>
                                    <td>
                                      {/* <RatingStars
                                        starProps={{ readOnly: true }}
                                        value={rq?.rating}
                                      /> */}
                                      <CustomStarRatings value={rq?.rating || 0} />
                                    </td>
                                    <td>{rq?.ratedBy?.name}</td>
                                    <td>{dayjs(rq?.ratedOn).format('DD MMM YYYY')}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </>
                    ) : (
                      <div className="text-center">No previous ratings given.</div>
                    )}
                  </div>
                </div>
              </Fragment>
            );
          })}
        </>
      ) : (
        <div className="text-center">No ratings given.</div>
      )}
    </>
  );
}

export default memo(TopicRatingHistory);
